import { useState, useRef, useEffect } from 'react';
import { DownloadFileLine, UploadFile } from '@icons';
import { Button, Spinner } from 'react-bootstrap';

const GenericDownloadUploadItems = ({ title, disabled, answerId }) => {
  const [data, setData] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGetLoading, setIsGetLoading] = useState(false);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const inputRef = useRef(null);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const openFileUpload = () => {
    inputRef.current.click();
  };
  const downloadFile = (blob, filename) => {
    const fileUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleDownload = async (documentId, data) => {
    //TODO: Qui va messa la logica per il download del file
    // setIsDownloadLoading(true);
    // setError(null);
    // const downloadResponse = await #
    // if (downloadResponse.ok === true) {
    //   const blob = await downloadResponse.blob();
    //   console.log('blob', data);
    //   const contentType = downloadResponse.headers.get('Content-Type');
    //   let filename = 'downloaded_file';
    //   if (data.fileName) {
    //     filename = data.fileName;
    //   }
    //   const file = new File([blob], filename, { type: contentType });
    //   downloadFile(file, filename);
    // } else if (!downloadResponse.ok || downloadResponse.status !== 200) {
    //   setError(downloadResponse.message || 'Something went wrong');
    // }
    // setIsDownloadLoading(false);
  };

  const handleFileUpload = async (selectedFileChange) => {
    // TODO: Qui va messa la logica, una volta che il file è stato selezionato, per l'upload del file
    // if (!selectedFileChange) return;
    // setIsLoading(true);
    // const formData = new FormData();
    // formData.append('file', file);
    // try {
    //   const response = #
    //   if (response.status) {
    //     setRefresh(true);
    //     setIsLoading(false);
    //   } else {
    //     setError(response.message || 'Something went wrong');
    //   }
    // } catch (error) {
    //   console.error('Error uploading file', error);
    // }
    // setIsLoading(false);
    // setFile(null);
  };

  useEffect(() => {
    if (file) {
      handleFileUpload(file);
    }
  }, [file]);

  useEffect(() => {
    //   TODO: Qui va messa la logica, in caso di questionario già risposto o anche solo parzialmente della sezione allegati
    // if (!corporatequestionnaireId) return;
    // let isMounted = true;
    // return () => {
    //   isMounted = false;
    // };
  }, [answerId]);
  // useEffect(() => {
  //   TODO: Qui va messa la logica di refresh della sezione allegati
  //   if (!refresh) return;
  //   let isMounted = true;
  //   if (isMounted) {
  //     setRefresh(false);
  //   }
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [refresh, answerId, setRefresh]);
  return (
    <div>
      <div className='d-flex justify-content-start align-items-center mr-4'>
        {!!title && (
          <p
            className='mb-1 p-0'
            style={{
              whiteSpace: 'nowrap',
              fontSize: '.9rem',
              color: disabled ? 'grey' : 'inherit',
            }}>
            {title}:
          </p>
        )}

        <div className='d-flex justify-content-start align-items-center ml-3'>
          {isLoading ? (
            <Spinner animation='border' role='status' size='md' />
          ) : (
            <>
              <Button
                variant='link'
                // disabled={disabled || isLoading}
                title={'Carica file'}
                onClick={() => openFileUpload()}
                style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}
                disabled={disabled || isGetLoading}>
                <UploadFile width='23px' className='light-color m-0' />
              </Button>
              <input
                type='file'
                id='file-input-dat'
                ref={inputRef}
                onChange={handleFileChange}
                disabled={disabled || isGetLoading}
                style={{ display: 'none' }}
              />
              <label
                style={{ display: 'none' }}
                className='file-input-dat'
                htmlFor='file-input-dat'></label>
            </>
          )}
          <div className='d-flex'>
            {isDownloadLoading ? (
              <Spinner animation='border' role='status' size='md' className='ml-2' />
            ) : (
              <>
                <Button
                  variant='link'
                  title='Download file'
                  onClick={() => handleDownload(data?.[0].id, data?.[0])}
                  disabled={disabled || isGetLoading || !data?.[0]?.id}
                  className='ml-3'
                  style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
                  <DownloadFileLine width='23px' className='light-color m-0' />
                </Button>
                {data && (
                  <p className='m-0 p-0' style={{ fontSize: '.9rem' }}>
                    {data?.[0]?.name}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* {error && <StatusBar status={'error'} message={error} timeout={false} />} */}
    </div>
  );
};

export default GenericDownloadUploadItems;
